import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const STORE_API = `${BACKEND_URL}/api/public`;

/** Public (unauthenticated) API client for the storefront. */
export const storeApi = axios.create({
  baseURL: STORE_API,
  withCredentials: false,
  headers: { "Content-Type": "application/json" },
});

export function formatStoreError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join("; ");
  return JSON.stringify(detail);
}

export function formatPrice(value, currency = "USD") {
  const n = Number(value || 0);
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(n);
  } catch {
    return `$${n.toFixed(2)}`;
  }
}

export function productUrl(product) {
  if (!product) return "/";
  const key = product.seo_slug || product.id || product.asin;
  return `/p/${key}`;
}
